import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"
import loader from "./../../../../assets/loading/loader.gif"

const EditVendorLoan = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoading, setPageLoading] = useState(true)
  const [loan, setLoan] = useState(null)
  const [companies, setCompanies] = useState([])
  const [allPlants, setAllPlants] = useState([])
  const [plants, setPlants] = useState([])
  const [allCenters, setAllCenters] = useState([])
  const [centers, setCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [vendors, setVendors] = useState([])

  const a = r => Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []

  useEffect(() => {
    const getInfo = async () => {
      try {
        const [loansResp, coResp, plResp, ccResp] = await Promise.all([
          api.get("vendor-loan/" + id), api.get("companies"), api.get("plants"), api.get("centers")
        ])
        const loanData = loansResp.data.data?.[0] || loansResp.data.data
        setLoan(loanData)
        setCompanies(a(coResp))
        const pl = a(plResp); setAllPlants(pl); setPlants(pl)
        const cc = a(ccResp); setAllCenters(cc); setCenters(cc)
        // Pre-load routes and vendors based on existing loan data
        if (loanData?.chillingCenter) {
          try { setRoutes(a(await api.get("route-cc/" + loanData.chillingCenter))) } catch (e) {}
        }
        if (loanData?.route) {
          try { setVendors(a(await api.get("vendors"))) } catch (e) {}
        }
      } catch (err) { console.error(err) }
      setPageLoading(false)
    }
    getInfo()
  }, [id])

  const showCompany = companies.length > 1
  const companyChange = async v => { setCenters(allCenters); setRoutes([]); setVendors([]); if (v) { try { setPlants(a(await api.get("plants-by-company/" + v))) } catch (e) {} } else setPlants(allPlants) }
  const plantChange = async v => { setRoutes([]); setVendors([]); if (v) { try { setCenters(a(await api.get("chillings-by-plant/" + v))) } catch (e) {} } else setCenters(allCenters) }
  const ccChange = async v => { setVendors([]); if (v) { try { setRoutes(a(await api.get("route-cc/" + v))) } catch (e) {} } else setRoutes([]) }
  const routeChange = async v => { if (v) { try { setVendors(a(await api.get("vendors"))) } catch (e) {} } else setVendors([]) }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const response = await api.put("update-vendor-loan/" + id, values)
      if (response.data.success === true) { setSubmitted(true); setTimeout(() => setSubmitted(false), 3000) }
    } catch (error) { console.error(error) }
    setLoading(false)
  }

  if (pageLoading) return <div className="dashBody"><img className="loaderImg" src={loader} alt="Loading" /></div>
  if (!loan) return <div className="dashBody"><p>Loan not found</p></div>

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row><Col md={6}><h4>Edit Vendor Loan</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}><Link to="/vendor-loans" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col></Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal" onValidSubmit={handleValidSubmit}>
          {showCompany && <Row><Col md={6}><div className="mb-3"><AvField type="select" name="company" label="Company" onChange={e => companyChange(e.target.value)}>
            <option value="">All</option>{companies.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}</AvField></div></Col></Row>}
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="plant" label="Plant" onChange={e => plantChange(e.target.value)}>
              <option value="">All Plants</option>{plants.map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}</AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="chillingCenter" label="Chilling Center *" required value={String(loan.chillingCenter)} onChange={e => ccChange(e.target.value)}>
              <option value="">Select Chilling Center</option>{centers.map((c, i) => <option key={i} value={String(c.id)}>{c.name}</option>)}</AvField></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="route" label="Route *" required value={String(loan.route)} onChange={e => routeChange(e.target.value)}>
              <option value="">Select Route</option>{routes.map((r, i) => <option key={i} value={String(r.id)}>{r.routeName}</option>)}</AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="bulkVendor" label="Vendor *" required value={String(loan.bulkVendor)}>
              <option value="">Select Vendor</option>{vendors.map((v, i) => <option key={i} value={String(v.id)}>{v.vendorName}</option>)}</AvField></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField name="loanDate" label="Loan Date *" type="date" required value={loan.loanDate} /></div></Col>
            <Col md={6}><div className="mb-3"><AvField name="loanAmount" label="Loan Amount *" type="text" required value={loan.loanAmount} /></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField name="deductionAmount" label="Deduction Amount *" type="text" required value={loan.deductionAmount} /></div></Col>
            <Col md={6}><div className="mb-3"><AvField name="remarks" label="Remarks" type="textarea" value={loan.remarks} /></div></Col>
          </Row>
          <div className="mb-3 row mt-4">
            <div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>Vendor Loan Updated!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end"><button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
              {loading ? <><Spinner size="sm" /> Updating...</> : "Update Loan"}</button></div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}
export default EditVendorLoan
